export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87')
];

export const server_loads = [];

export const dictionary = {
		"/": [14],
		"/accounts/all": [15,[2]],
		"/accounts/all/[id]": [16,[2]],
		"/accounts/cards": [17,[2]],
		"/accounts/companies": [18,[2]],
		"/accounts/companies/[id]": [19,[2]],
		"/accounts/transactions": [20,[2]],
		"/accounts/users": [21,[2]],
		"/accounts/users/[id]": [22,[2]],
		"/app/news": [23],
		"/app/news/add": [25],
		"/app/news/[id]/edit": [24],
		"/app/splash-screens": [26,[3]],
		"/app/splash-screens/add": [28,[3]],
		"/app/splash-screens/[id]/edit": [27,[3]],
		"/app/translation-module": [29],
		"/app/user-database": [30],
		"/condos": [31,[4]],
		"/condos/all": [54,[4]],
		"/condos/automatic-orders": [55,[4]],
		"/condos/board-members": [56,[4]],
		"/condos/board-members/[id]": [57,[4]],
		"/condos/change-requests": [58,[4]],
		"/condos/database": [59,[4]],
		"/condos/orders": [60,[4]],
		"/condos/portal-operations": [61,[4]],
		"/condos/providers": [62,[4]],
		"/condos/providers/[id]": [63,[4]],
		"/condos/services": [64,[4]],
		"/condos/transactions": [65,[4,10]],
		"/condos/transactions/credit": [66,[4,10]],
		"/condos/transactions/debit": [67,[4,10]],
		"/condos/transactions/upcoming": [68,[4,10]],
		"/condos/[id]/accounts/companies": [32,[4,5,6]],
		"/condos/[id]/accounts/list": [33,[4,5,6]],
		"/condos/[id]/accounts/transactions": [34,[4,5,6]],
		"/condos/[id]/accounts/users": [35,[4,5,6]],
		"/condos/[id]/condo/automatic-orders": [36,[4,5,7]],
		"/condos/[id]/condo/balance": [37,[4,5,7]],
		"/condos/[id]/condo/board-members": [38,[4,5,7]],
		"/condos/[id]/condo/orders": [39,[4,5,7]],
		"/condos/[id]/condo/portal-operations": [40,[4,5,7]],
		"/condos/[id]/condo/portal-subscriptions": [41,[4,5,7]],
		"/condos/[id]/condo/portal-users": [42,[4,5,7]],
		"/condos/[id]/condo/providers": [43,[4,5,7]],
		"/condos/[id]/condo/services": [44,[4,5,7]],
		"/condos/[id]/condo/sms-history": [46,[4,5,7]],
		"/condos/[id]/condo/sms": [45,[4,5,7]],
		"/condos/[id]/condo/sum": [47,[4,5,7]],
		"/condos/[id]/condo/transactions": [48,[4,5,7,8]],
		"/condos/[id]/condo/transactions/credit": [49,[4,5,7,8]],
		"/condos/[id]/condo/transactions/debit": [50,[4,5,7,8]],
		"/condos/[id]/condo/transactions/upcoming": [51,[4,5,7,8]],
		"/condos/[id]/devices/issues": [52,[4,5,9]],
		"/condos/[id]/devices/list": [53,[4,5,9]],
		"/dashboard": [69],
		"/devices/all": [72,[11]],
		"/devices/issues": [73,[11]],
		"/devices/issues/[id]": [74,[11]],
		"/devices/[id]": [70,[11,12]],
		"/devices/[id]/slots": [71,[11,12]],
		"/forgot-password": [75],
		"/manage/api-tokens": [76],
		"/manage/changelogs": [77],
		"/manage/list": [78],
		"/manage/list/add": [79],
		"/manage/list/edit/[id]": [80],
		"/manage/permissions": [81],
		"/manage/roles": [82],
		"/manage/terms-and-conditions/common": [83],
		"/manage/terms-and-conditions/individual": [84],
		"/sms/history": [85,[13]],
		"/sms/send": [86,[13]],
		"/sms/templates": [87,[13]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';